const supportsNativeSmoothScroll =
  typeof document !== 'undefined' && 'scrollBehavior' in document.documentElement.style;

export const scrollToTopOfPage = () => {
  window.scroll({
    top: 0,
    behavior: supportsNativeSmoothScroll ? 'smooth' : 'auto',
  });
};
